<template lang="html">
    <div class="footer">
        <div class="logo-wrapper">
            <div class="logo">
                <img src="../../assets/LogoCEED.svg" alt="Logo" />
            </div>
        </div>
        <div class="container">
            <ul class="list-items">
                <li class="item active">
                    <router-link to="/" class="link">Inicio</router-link>
                </li>
                <li class="item">
                    <router-link to="/nosotros" class="link">Nosotros</router-link>
                </li>
                <li class="item">
                    <router-link to="/recursos" class="link">Recursos</router-link>
                </li>
                <li class="item">
                    <router-link to="/observatorio" class="link">Observatorio</router-link>
                </li>
                <li class="item">
                    <router-link to="/eventos" class="link">Eventos</router-link>
                </li>
                <li class="item">
                    <router-link to="/contacto" class="link">Contacto</router-link>
                </li>
            </ul>
            <div class="social">
                <a href="#" class="item">
                    <img src="../../assets/social-fb.png" alt="facebook-social" />
                </a>
                <a href="#" class="item">
                    <img src="../../assets/social-tw.png" alt="twitter-social" />
                </a>
                <a href="#" class="item">
                    <img src="../../assets/social-ld.png" alt="linkedin-social" />
                </a>
            </div>
        </div>
        <div class="rights">
            <div class="container">
                <span class="text">Copyright © 2022 Todos los derechos reservados.</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="css" scoped>
.footer {
    background: linear-gradient(92.47deg, #013754 -11.1%, #001a28 133.58%);
    padding-top: 30px;
}
.footer .logo-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}
.footer .logo-wrapper .logo {
    width: 150px;
}
.footer .logo-wrapper .logo img {
    width: 100%;
}
.footer .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
}
.footer .container .list-items {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
}
.footer .container .list-items .item {
    list-style: none;
    margin: 0 30px;
}
.footer .container .list-items .item:first-child {
    margin-left: 0;
}
.footer .container .list-items .item:last-child {
    margin-right: 0;
}
.footer .container .list-items .item .link {
    text-decoration: none;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: #dadada;
}
.footer .container .list-items .item .link.router-link-active {
    font-weight: 900;
    color: #ffffff;
}
.footer .container .social .item:nth-child(2) {
    margin: 0 20px;
}
.footer .rights {
    padding: 12px 0;
    margin-top: 45px;
    background: #002a41;
}
.footer .rights .text {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #dadada;
}
@media (max-width: 1200px) {
    .footer .container {
        flex-direction: column;
    }
    .footer .container .list-items {
        margin-bottom: 50px;
    }
}
@media (max-width: 992px) {
    .footer .logo-wrapper {
        margin-top: 40px;
        margin-bottom: 50px;
    }
    .footer .logo-wrapper .logo {
        width: 160px;
    }
    .footer .container .list-items {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        row-gap: 24px;
    }
    .footer .container .list-items .item {
        margin: 0;
    }
    .footer .rights .text {
        text-align: center;
        font-size: 12px;
        line-height: 14px;
    }
}
</style>